export const inventoryFields = [
  {
    name: "itemCode",
    label: "Item Code",
    type: "autocomplete",
    required: true,
    
  },
   {
    name: "itemDescription",
    label: "Item Description",
    type: "text",
    readonly: true
  },
  {
    name: "locationId",
    label: "Location",
    type: "autocomplete",
    required: true
  },
  {
    name: "locationName",
    label: "Location Name",
    type: "text",
    readonly: true
  },
   {
    name: "locationType",
    label: "Location Type",
    type: "text",
    readonly: true
  },
  {
    name: "stockOnHand",
    label: "Stock On Hand",
    type: "number",
    required: true
  },
  {
    name: "allocatedQty",
    label: "Allocated Qty",
    type: "number",
    readonly: true
  },
  {
    name: "availableQty",
    label: "Available Qty",
    type: "number",
    readonly: true
  },
  {
    name: "batchLot",
    label: "Batch/Lot",
    type: "text",
  
  },

  {
    name: "expiryDate",
    label: "Expiry Date",
    type: "date"
    
  },

  {
    name: "availability",
    label: "Availability",
    type: "select",
    options: ["In Stock", "Out Of Stock", "Pre-order", "Back-order"]
  },

  {
    name: "nonSellableQty",
    label: "Non Sellable Qty",
    type: "number"
  },
  {
    name: "createdBy",
    label: "Created By",
    type: "text",
    readonly: true
  },

  {
    name: "updatedBy",
    label: "Updated By",
    type: "text",
    readonly: true
  },
  {
    name: "channelAllocation",
    label: "Channel Allocation",
    type: "array",
    fields: [
      {
        name: "channelId",
        label: "Channel",
        type: "select"
      },
      {
        name: "allocationPercent",
        label: "Allocation %",
        type: "number"
      }
    ]
  },

  


];